import { render, staticRenderFns } from "./magic-sidebar.vue?vue&type=template&id=5a18f0c9&scoped=true&"
import script from "./magic-sidebar.vue?vue&type=script&lang=js&"
export * from "./magic-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./magic-sidebar.vue?vue&type=style&index=0&id=5a18f0c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a18f0c9",
  null
  
)

export default component.exports